export function spNavSwitch() {
    const slideMenu = document.getElementById('slideMenu');
    const slideMenu_switch = document.getElementById('slideMenu_switch');
    const slideMenu_circle = document.getElementById('slideMenu_circle');
    const slideMenu_duration = 400;

    slideMenu_switch.addEventListener('click', function () {

        if (!slideMenu.classList.contains('open')) {


            slideMenu_switch.classList.add('open');
            slideMenu_switch.style.setProperty('pointer-events', 'none')


            slideMenu.style.setProperty('right', '0');

            setTimeout(function () {
                slideMenu_circle.style.setProperty('display', 'block');
            }, slideMenu_duration);

            setTimeout(function () {
                slideMenu_circle.style.setProperty('left', '0');
            }, slideMenu_duration + 30);

            setTimeout(function () {
                slideMenu.classList.add('open');

                slideMenu_switch.style.setProperty('pointer-events', null)
            }, slideMenu_duration * 2)


        } else {


            slideMenu_switch.style.setProperty('pointer-events', 'none')

            slideMenu_circle.style.setProperty('left', null);

            setTimeout(function () {
                slideMenu_circle.style.setProperty('display', null);

                slideMenu.style.setProperty('right', null);

                slideMenu_switch.style.setProperty('pointer-events', null)
                slideMenu_switch.classList.remove('open');
            }, slideMenu_duration)

            setTimeout(function () {
                slideMenu.classList.remove('open');
            }, slideMenu_duration * 2)


        }
    })

    if ( document.body.id === 'top'){

        window.addEventListener('scroll',function (){
            let winPos = window.pageYOffset;
            if ( winPos < (window.innerWidth * 0.28 - 25) ){
                let newPos = 'calc(28vw - ' + winPos + 'px)';
                slideMenu_switch.style.setProperty('transition', 'none');
                slideMenu_switch.style.setProperty('top', newPos);

                setTimeout(function (){
                    slideMenu_switch.style.setProperty('transition', null);
                })
            }
            else {
                slideMenu_switch.style.setProperty('top', '25px');
            }
        })

    }
}